var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Diario',{staticClass:"pa-5",staticStyle:{"border-radius":"0px"}})}
var staticRenderFns = []

export { render, staticRenderFns }